import React from 'react';
import { Expense } from '../../../../interfaces/delivery-company/expenses';
import CustomDialog, {
  CustomDialogProps,
} from '../../../common/custom-dialog/custom-dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import RecurrentExpenseForm from './recurrent-expense-form';
import { RecurrentExpense } from '../../../../interfaces/delivery-company/recurrent-expenses';
import { isMobile, isTablet } from 'react-device-detect';

function RecurrentExpenseFormDialog({
  defaultRecurrentExpense,
  onClose,
  onSuccess,
}: {
  defaultRecurrentExpense?: RecurrentExpense;
  onSuccess: (e: RecurrentExpense) => void;
} & CustomDialogProps) {
  return (
    <CustomDialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={(isMobile && !isTablet)}
    >
      <DialogContent>
        <RecurrentExpenseForm
          onSuccess={(e) => {
            onSuccess(e);
            onClose && onClose();
          }}
          defaultRecurrentExpense={defaultRecurrentExpense}
        />
      </DialogContent>
    </CustomDialog>
  );
}

export default RecurrentExpenseFormDialog;
